import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=96802214"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"
import style0 from "./Button.vue?vue&type=style&index=0&id=96802214&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../repos/mylovelyladyhere.com/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports